import React from "react";
import { useTranslation } from "react-i18next";

import { Participation } from "../../schemas/collaborateur/collaborateur.schema";
import { formatDate } from "../../utils";
import Button from "../global/Button/Button";
import LinkButton from "../global/Button/LinkButton/LinkButton";

import { useNavigate } from "react-router-dom";
import { continuerModificationIcon } from "../../assets/svgs/icons/icons.svg";
import { rightIcon } from "../../assets/svgs/rightArrow";
import { useEtablissementStore } from "../../stores/etablissement/etablissement.store";
import CustomeModal from "../CustomeModal/CustomeModal";
import styles from "./ConfirmeParticipationPopup.module.scss";
type Props = {
  type: "addCollaborateur" | "editCollaborateur";
  partcipation: Participation | null;
  isOpen: boolean;
  setIsOpen:
  | React.Dispatch<React.SetStateAction<boolean>>
  | ((newState: boolean) => void);
  cancelButtonText: string;
  confirmButtonText: string;
  onConfirm?: () => void;
  navigateTo: string

};

export default function ConfirmeParticipationPopup(props: Props) {
  const { t } = useTranslation();
  const {
    type,
    partcipation,
    isOpen,
    setIsOpen,
    cancelButtonText,
    confirmButtonText,
    onConfirm,
    navigateTo
  } = props;
  //* react-router-dom
  const navigate = useNavigate()
  const { setSelectedEtablissement, setSelectedParticipation } = useEtablissementStore()
  function onClickClose() {
    setSelectedEtablissement(null)
    setSelectedParticipation(null)
    setIsOpen(false);
  }


  return (
    <CustomeModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onClose={onClickClose}
    >
      <article className={styles.confirmeParticipationPopup}>
        <header className={styles.confirmeParticipationPopup__header}>
          <h1>{t("confirmeParticipationPopup.title")}</h1>
        </header>
        <main className={styles.confirmeParticipationPopup__main}>
          <section>
            <p>{t("confirmeParticipationPopup.description1")}</p>
          </section>
          <section
            className={styles.confirmeParticipationPopup__main__participation}
          >
            <strong> {partcipation && partcipation.etablissementName} </strong>
            <strong>
              {partcipation &&
                formatDate(partcipation?.dateParticipation, { hasDayName: true })}
            </strong>
          </section>
          <section>
            <p>{t("confirmeParticipationPopup.description2")}</p>
          </section>
        </main>
        <footer className={styles.confirmeParticipationPopup__footer}>
          <Button
            text={cancelButtonText}
            textColor="dark"
            buttonBackGroundColor="white"
            onClick={onClickClose}
          />
          {type === "addCollaborateur" && (
            <LinkButton text={confirmButtonText} to={navigateTo} iconRight={rightIcon} />
          )}
          {type === "editCollaborateur" && (
            <Button
              buttonBackGroundColor="blue"
              textColor="white"
              text={confirmButtonText}
              onClick={() => navigate(navigateTo)}
              rightIcon={continuerModificationIcon}
            />
          )}
        </footer>
      </article>
    </CustomeModal>
  );
}
